import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
//servizio per la condivisione dei dati di giustificazione e note tra tabella e form di giustifica
export class JustificationService {
  private justificationSubject = new BehaviorSubject<string>('');
  private noteSubject = new BehaviorSubject<string>('');
  private dateSubject = new BehaviorSubject<Date>(new Date());

  //aggiorno il valore della giustifica
  setJustification(justification: string): void {
    this.justificationSubject.next(justification);
  }

  //ritorno il valore della giustifica
  getJustification() {
    return this.justificationSubject.asObservable();
  }
  //aggiorno il valore della nota
  setNote(note: string): void {
    this.noteSubject.next(note);
  }

  //ritorno il valore della nota
  getNote() {
    return this.noteSubject.asObservable();
  }

  setDate(date: Date): void {
    this.dateSubject.next(date); 
  }

  getDate() {
    return this.dateSubject.asObservable(); 
  }
}
